import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useStyles } from '../styles'
import { useVaultContext } from '../../VaultContextProvider'
import { defaultDocumentDetailsLabel } from '../../constants'
import Tag from '../../../../atoms/Tag'

export const DocumentDetailVariantTags = ({
  document
}) => {
  const classes = useStyles()
  const { labels } = useVaultContext()

  return (
    <div className={classes.detailsBlock}>
      <div className={classes.detailBlockTitle}>
        {labels?.documentDetails?.variantTag ?? defaultDocumentDetailsLabel.variantTag}
      </div>
      <div className={clsx([classes.detailBlockContent, classes.tagContent])}>
        {document.documentVariants.map(variant => {
          const variantType = variant.name.split('.').pop()
          return (
            <Tag
              key={variantType}
              label={variantType.toUpperCase()}
              backgroundColor='var(--color-primary-500)'
              color='var(--color-contrast-primary-500)'
            />
          )
        })}
      </div>
    </div>
  )
}

DocumentDetailVariantTags.propTypes = {
  document: PropTypes.object.isRequired
}
